import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { LogVisualizerService } from 'src/app/shared/services/API/srvlog/log-visualizer.service';
import { HealthUnitService } from 'src/app/shared/services/API/user/health-unit.service';
import { ListHealthUnitStruct } from 'src/app/shared/services/structs/admin-user/list-health-unit.struct';
import { ListLogStruct } from 'src/app/shared/services/structs/srvlog/list-log.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';

@Component({
  selector: 'app-log-visualizer-list',
  templateUrl: './log-visualizer-list.component.html',
  styleUrls: ['./log-visualizer-list.component.css']
})
export class LogVisualizerListComponent implements OnInit, OnDestroy {

  constructor(private alertService: AlertService,
    private healthUnitService: HealthUnitService,
    private logVisualizerService: LogVisualizerService,
    private configService: AppConfigService,
    private endpointBuilder: EndpointBuilderService) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  public menuModuleEnum: MenuModuleEnum = MenuModuleEnum.developer;
  public menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.log_list;
  public isLoading: boolean;
  public listLogs: ListLogStruct[];
  public listHealthUnit: ListHealthUnitStruct[];
  public fullListSize: number;
  public searchText: string;
  public beginDate: Date;
  public idLog: number;
  public type: string;
  public endDate: Date;
  public idHealthUnit: number;
  private interval: any;
  public isPanelMode: boolean;
  public latestId: number;
  public urlListHealthUnit: string = this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + "ListHealthUnit";
  public listIdHealthUnit: number[] = [];
  public pageIndex: number = 0;

  ngOnInit(): void {
    this.populateHealthUnitSelect();
    this.latestId = 0;

    const savedState = sessionStorage.getItem('LogVisualizer_State');
    if (savedState) {
      const state = JSON.parse(savedState);
      this.idLog = state.idLog;
      this.searchText = state.searchText;
      this.listIdHealthUnit = state.listIdHealthUnit || [];
      this.type = state.type;
      this.beginDate = state.beginDate ? new Date(state.beginDate) : undefined;
      this.endDate = state.endDate ? new Date(state.endDate) : undefined;
      this.isPanelMode = state.isPanelMode;
      this.listLogs = state.listLogs;
      this.fullListSize = state.fullListSize;
      this.pageIndex = state.pageIndex || 0;
    } else {
      this.search(0);
    }
  }

  search(pageIndex: number) {
    this.isLoading = true;
    this.pageIndex = pageIndex;

    if (this.searchText == "")
      this.searchText = null;

    if (this.beginDate)
      this.beginDate.setHours(0);

    if (this.endDate) {
      this.endDate.setHours(23);
      this.endDate.setMinutes(59);
    }

    this.logVisualizerService.listLogWithListHealthUnit(this.idLog, this.listIdHealthUnit, this.type, this.searchText, this.beginDate, this.endDate, pageIndex).subscribe((response) => {
      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }

      if (this.latestId < response.listLogs[0]?.idLog) {
        this.latestId = response.listLogs[0]?.idLog;
        if (this.isPanelMode) {
          let audio = new Audio();
          audio.src = "https://storage.googleapis.com/tolife-production-public-storage/admin_error_hey_listen.mp3";
          audio.load();
          audio.play();
        }
      }
      this.fullListSize = response.fullListSize;
      this.listLogs = response.listLogs;
      this.isLoading = false;

      this.saveState();
    },
      (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  saveState() {
    const state = {
      idLog: this.idLog,
      searchText: this.searchText,
      listIdHealthUnit: this.listIdHealthUnit,
      type: this.type,
      beginDate: this.beginDate,
      endDate: this.endDate,
      isPanelMode: this.isPanelMode,
      listLogs: this.listLogs,
      fullListSize: this.fullListSize,
      pageIndex: this.pageIndex
    };
    sessionStorage.setItem('LogVisualizer_State', JSON.stringify(state));
  }

  clearSearch() {
    this.idLog = undefined;
    this.searchText = undefined;
    this.beginDate = undefined;
    this.endDate = undefined;
    this.type = undefined;
    this.listIdHealthUnit = [];
    this.isPanelMode = false;
    this.listLogs = undefined; 
    this.fullListSize = 0;
    this.pageIndex = 0;

    sessionStorage.removeItem('LogVisualizer_State');
  }

  changePage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.search(event.pageIndex);
  }

  buttonSearch() {
    if (this.isLoading)
      return;

    if (this.paginator) {
      this.paginator.firstPage();
    }
    
    this.search(0);
  }

  populateHealthUnitSelect() {
    this.healthUnitService.listHealthUnit().subscribe((response) => {
      if (response.isError) {
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        return;
      }
      this.listHealthUnit = response.listHealthUnit;
    },
      (error) => {
        console.log(error)
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  getHealthUnitName(idHealthUnit: number): string {
    if (idHealthUnit == -1)
      return "Admin";

    if (!this.listHealthUnit || this.listHealthUnit.length <= 0)
      return "";

    return this.listHealthUnit.find(l => l.idHealthUnit == idHealthUnit)?.healthUnitName;
  }

  changeMode(event: any) {
    if (event.checked) {
      var $this = this;
      this.interval = setInterval(function () {
        $this.search(0);
        if (!$this.isPanelMode) clearInterval($this.interval);
      }, 10000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  selectHealthUnit(event) {
    this.listIdHealthUnit = event.map(x => x.idHealthUnit);
  }
}